var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"update-banner text-white u-flex u-flex--center"},[_vm._v(" Ein Update ist verfügbar. "),_c('button',{staticClass:"text-white u-reset-button u-inline-block u-underline p-0 ml-6",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("Jetzt aktualisieren!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }